module.exports = __webpack_public_path__ + "static/img/login-icon.d9ce9de6.png";